import { render } from "./EditEmail.vue?vue&type=template&id=3a0ddd35&scoped=true"
import script from "./EditEmail.vue?vue&type=script&lang=js"
export * from "./EditEmail.vue?vue&type=script&lang=js"

import "./EditEmail.vue?vue&type=style&index=0&id=3a0ddd35&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0ddd35"]])

export default __exports__